import { useMediaQuery } from "@certn/cascadia-react/hooks/useMediaQuery";
import { breakpoints } from "@certn/cascadia-tokens";
import { useEffect, useState } from "react";

export function useDetectMobileKeyboardOpen(minKeyboardHeight: number = 300) {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const isMobile = useMediaQuery(
    `(max-width: ${breakpoints["breakpoint-sm"].maxWidth.toString()}px)`
  );

  useEffect(() => {
    const listener = () => {
      let visualHeight: number | undefined;
      if (window?.visualViewport?.height) {
        visualHeight = window.visualViewport.height;
      }

      let newState = isKeyboardOpen;
      if (visualHeight) {
        newState = window.screen.height - minKeyboardHeight > visualHeight;
      }

      if (isKeyboardOpen !== newState) {
        setIsKeyboardOpen(newState);
      }
    };
    if (typeof visualViewport != "undefined") {
      window.visualViewport?.addEventListener("resize", listener);
    }
  }, [window.visualViewport?.height]);

  return isKeyboardOpen && isMobile;
}
